import React, { useEffect, useState } from 'react';
import api from '../services/api';
import type UserModel from '../models/UserModel';
import LoadingSpinner from './LoadingSpinner';

type PropTypes = {
    selectedUser: UserModel;
    setSelectedUser: (selectedUser: UserModel) => void;
};

function UserSearchField({ selectedUser, setSelectedUser }: PropTypes) {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([] as UserModel[]);
    const [searching, setSearching] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const pullResults = async () => {
        const { users } = await api.getUsers(undefined, searchTerm, 5);
        setSearchResults(users);
    };

    useEffect(() => {
        if (searchTerm) {
            setSearching(true);
            const delayDebounceFn = setTimeout(async () => {
                await pullResults();
                setSearching(false);
            }, 500);

            return () => {
                clearTimeout(delayDebounceFn);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);

    const handleSelect = (result: UserModel) => {
        setSelectedUser(result);
        setSearchTerm(result.username);
    };

    const onFocus = async () => {
        await pullResults();
        setIsFocused(true);
    };

    const onBlur = () => {
        setTimeout(() => {
            setIsFocused(false);
        }, 250);
    };

    return (
        <div className="flex items-center border relative border-black rounded p-1 w-1/2">
            <input
                className="text-primary w-full outline-0"
                type="text"
                name="participant"
                value={isFocused ? searchTerm : selectedUser.username}
                onChange={(event) => {
                    setSearchTerm(event.target.value);
                }}
                onFocus={onFocus}
                onBlur={onBlur}
            />
            {searching && <LoadingSpinner size={15} />}
            {isFocused && (
                <div className="border border-slate-300 rounded absolute bg-white text-primary w-full top-9 z-10">
                    {searchResults?.map((result: UserModel, index: number) => {
                        return (
                            <div
                                key={result.id}
                                id={`search-result-${index}`}
                                className="cursor-pointer hover:bg-slate-100 p-1"
                                onClick={() => {
                                    handleSelect(result);
                                }}
                            >
                                {result.username}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default UserSearchField;
